import type { OpcaoMotivoPadrao } from '../catalogo-motivo-padrao.tipos'
export type ListarOpcoesMotivoPadraoRepositorio = (
  sinal: AbortSignal,
) => Promise<readonly OpcaoMotivoPadrao[]>
export const criarCasoDeUsoListarOpcoesMotivoPadrao = (
  repositorio: ListarOpcoesMotivoPadraoRepositorio,
): ListarOpcoesMotivoPadraoRepositorio => async (sinal) => repositorio(sinal)
